import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useAccessToken } from '../auth/AccessTokenContext';
import { getApiV1AnalogueModelsByIdResultsObject } from '../api/generated';
import { queryKeys } from './queryKeys';

export const useFetchObjectResults = () => {
  const { modelId } = useParams();
  const token = useAccessToken();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.objectResults(modelId as string),
    queryFn: () =>
      getApiV1AnalogueModelsByIdResultsObject({
        path: { id: modelId as string },
      }),
    select: (res) => res.data?.data ?? [],
    enabled: !!token && !!modelId,
    refetchOnMount: 'always',
  });

  return query;
};
